import React from "react";

const GridFive = () => {
    return(
        <div className="item-five">
            <div className="myContent">
            <h1>Graphic Design</h1>
            <p>Great design makes you memorable. We deliver artwork that underscores your brand message and captures potential clients' attention</p>
            </div>
        </div>
    )
}

export default GridFive;